export const SURVEY_RESPONSES = {
  VERY_SATISFIED: 'Very Satisfied',
  SATISFIED: 'Satisfied',
  NEUTRAL: 'Neutral',
  UNSATISFIED: 'Unsatisfied',
  VERY_UNSATISFIED: 'Very Unsatisfied'
}
